import { Component, EventEmitter, Injector, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormType } from 'src/app/common/enumerations/enumerations';
import { CommentsAndAttachmentsComponent } from 'src/app/controls/comments-and-attachments/comments-and-attachments.component';
import { Form } from 'src/app/services/forms/form';
import { PpstbMainS1Component } from './ppstb-main-s1/ppstb-main-s1.component';
import { PpstbService } from '../ppstb.service';

@Component({
  selector: 'ppstb-main',
  templateUrl: './ppstb-main.component.html',
  styleUrls: ['./ppstb-main.component.scss']
})
export class PpstbMainComponent extends BaseComponent implements OnChanges {
  @Input() form?: Form | null;
  @Input() showAmendment?: boolean;
  @Output() formCreated = new EventEmitter<Form>();
  @Output() formCancelled = new EventEmitter<Form | null | undefined>();

  @ViewChild(PpstbMainS1Component) section1!: PpstbMainS1Component;
  @ViewChild(CommentsAndAttachmentsComponent) comments!: CommentsAndAttachmentsComponent;

  constructor(
    protected override injector: Injector,
    public service: PpstbService
  ) {
    super(injector);
  }

  /**
   * Whether the OIC has signed the Interlock Functional Test in Verification of Operation (section 7),
   * after which Worker Verification can no longer be signed or removed.
   */
  get interlockTestSigned(): boolean {
    // Bug 6926: lock Worker Verification once the Interlock Functional Test is signed.
    return this.form?.wfTable?.wfTableLocal?.wfSectionLocals?.find(s => s.number == 7)?.wfSignatures?.some(s => s.code == 'MITREMOVAL-INTERLOCK-TEST' && s.signed) ?? false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.comments && this.form) {
      this.comments.currentDocument = {
        status: this.form.formVersion?.statusID,
        serialNo: this.form.sequenceNumber?.number,
        type: FormType.PPSTB,
      };
      this.comments?.refresh();
    }
    this.setHeights();
  }

}
